// extracted by mini-css-extract-plugin
module.exports = {"blank":"blank--3vUjz","load":"load--YHUE2","Img":"Img--2pDfi","text":"text--bT_2V","retry":"retry--3gJCf","button":"button--2q_Qp"};